import React from "react";
import Icon from "src/icons";

const CrossSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fill="none" fillRule="evenodd">
      <path d="M-4-4h24v24H-4z" />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M9.305 7.998l5.972-5.968a.92.92 0 0 0 0-1.303.92.92 0 0 0-1.303 0L8 6.692 2.026.725a.92.92 0 0 0-1.303 0 .92.92 0 0 0 0 1.303l5.972 5.967-5.972 5.97a.92.92 0 0 0 .651 1.572c.237 0 .471-.089.652-.269L8 9.301l5.974 5.97c.18.18.415.269.652.269a.92.92 0 0 0 .652-1.573l-5.973-5.97z"
      />
    </g>
  </svg>
);
export const CrossIcon = (props) => <Icon component={CrossSvg} {...props} />;
